"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var lodash_1 = require("lodash");
var mock_expense_1 = require("./mock-expense");
var expense_1 = require("./expense");
var environment_1 = require("../../environments/environment");
var api_service_1 = require("../shared/api.service");
var decamelizeKeysDeep = require('decamelize-keys-deep');
var ExpenseService = /** @class */ (function () {
    function ExpenseService(http) {
        this.http = http;
        this.baseUrl = environment_1.environment.serverUrl;
        this.count = 0;
    }
    ExpenseService.prototype.getMockExpense = function () { return mock_expense_1.EXPENSE; };
    ExpenseService.prototype.getExpense = function (expenseId) {
        var expenseUrl = this.baseUrl + 'expenses/' + expenseId + '/';
        return this.http.get(expenseUrl, { headers: api_service_1.requestHeaders() }).pipe(operators_1.map(this.extractData), operators_1.catchError(api_service_1.handleError));
    };
    ExpenseService.prototype.getMockExpenses = function (count) {
        var expenses = [];
        for (var i = 1; i <= count; i++) {
            var expense = Object.assign({}, mock_expense_1.EXPENSE);
            expenses.push(expense);
        }
        return expenses;
    };
    ExpenseService.prototype.getExpenses = function (query) {
        var _this = this;
        if (query === void 0) { query = null; }
        var params = new http_1.HttpParams();
        params = params.set('page_size', '10');
        if (query) {
            Object.keys(query).forEach(function (key) {
                if (typeof query[key] !== 'undefined' && query[key] && query[key].toString) {
                    params = params.set(key, query[key].toString());
                }
            });
        }
        var expensesUrl = this.baseUrl + 'expenses/';
        return this.http.get(expensesUrl, {
            headers: api_service_1.requestHeaders(),
            params: params
        }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
    };
    ExpenseService.prototype.save = function (expense) {
        var _this = this;
        expense = lodash_1.clone(expense);
        var expenseUrl = this.baseUrl + 'expenses/';
        if (typeof expense.job === 'object') {
            expense.job = expense.job.id;
        }
        if (typeof expense.customerOrganization === 'object') {
            expense.customerOrganization = expense.customerOrganization.id;
        }
        if (typeof expense.billFromCcEmails === 'string') {
            expense.billFromCcEmails = expense.billFromCcEmails.split(',');
        }
        if (typeof expense.billToCcEmails === 'string') {
            expense.billToCcEmails = expense.billToCcEmails.split(',');
        }
        expense = decamelizeKeysDeep(expense);
        if (!expense.id) {
            return this.http.post(expenseUrl, expense, {
                headers: api_service_1.requestHeaders()
            }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
        }
        else {
            return this.http.put(expenseUrl + expense.id + '/', expense, {
                headers: api_service_1.requestHeaders()
            }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
        }
    };
    ExpenseService.prototype.remove = function (expense) {
        expense = decamelizeKeysDeep(expense);
        var expenseUrl = this.baseUrl + 'expenses/';
        return this.http.delete(expenseUrl + expense.id + '/', { headers: api_service_1.requestHeaders() });
    };
    ExpenseService.prototype.unlock = function (expense) {
        expense = decamelizeKeysDeep(expense);
        var expenseUrl = this.baseUrl + 'expenses/';
        return this.http.put(expenseUrl + expense.id + '/', { sent: false }, { headers: api_service_1.requestHeaders() });
    };
    ExpenseService.prototype.send = function (expense) {
        expense = decamelizeKeysDeep(expense);
        var expenseUrl = this.baseUrl + 'expenses/';
        return this.http.post(expenseUrl + expense.id + '/send/', {
            payment_type: expense.payment_type
        }, { headers: api_service_1.requestHeaders() });
    };
    ExpenseService.prototype.addToExpense = function (expense, type) {
        var _this = this;
        if (type === void 0) { type = 'trips'; }
        expense = lodash_1.clone(expense);
        var params, filterParams;
        var expenseUrl = this.baseUrl + 'expenses/' + expense.id + '/add/';
        if (expense.filters && expense.filters.length) {
            filterParams = '?' + expense.filters;
            if (type === 'trips') {
                params = { trips: [], exclude_trips: expense.excludeTrips };
            }
            else if (type === 'punchcards') {
                params = { punchcards: [], exclude_punchcards: expense.excludePunchCards };
            }
        }
        else {
            filterParams = '';
            if (type === 'trips') {
                params = { trips: expense.trips || [] };
            }
            else if (type === 'punchcards') {
                params = { punchcards: expense.punchCards || [] };
            }
        }
        expense = decamelizeKeysDeep(expense);
        return this.http.post(expenseUrl + filterParams, params, {
            headers: api_service_1.requestHeaders()
        }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
    };
    ExpenseService.prototype.removeFromExpense = function (expense, type) {
        var _this = this;
        if (type === void 0) { type = 'trips'; }
        expense = decamelizeKeysDeep(lodash_1.clone(expense));
        var params, filterParams;
        var expenseUrl = this.baseUrl + 'expenses/' + expense.id + '/remove/';
        if (expense.filters && expense.filters.length) {
            filterParams = '?' + expense.filters;
            if (type === 'trips') {
                params = { trips: [], exclude_trips: expense.excludeTrips };
            }
            else if (type === 'punchcards') {
                params = { punchcards: [], exclude_punchcards: expense.excludePunchCards || expense.exclude_punch_cards };
            }
            else if (type === 'surcharges') {
                params = { surcharges: [], exclude_surcharges: expense.excludeSurcharges || expense.exclude_surcharges };
            }
        }
        else {
            filterParams = '';
            if (type === 'trips') {
                params = { trips: expense.trips || [] };
            }
            else if (type === 'punchcards') {
                params = { punchcards: expense.punchCards || expense.punchcards || [] };
            }
            else if (type === 'surcharges') {
                params = { surcharges: expense.surcharges || [] };
            }
        }
        return this.http.post(expenseUrl + filterParams, params, {
            headers: api_service_1.requestHeaders()
        }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
    };
    ExpenseService.prototype.export = function (scope, params) {
        if (params === void 0) { params = null; }
        var expenseUrl = this.baseUrl + 'expenses/export/';
        var _scope = lodash_1.clone(decamelizeKeysDeep(scope));
        return this.http.post(expenseUrl + '?' + params, _scope, {
            headers: api_service_1.requestHeaders()
        }).pipe(operators_1.catchError(api_service_1.handleError));
    };
    ExpenseService.prototype.downloadPdfs = function (scope, params) {
        if (params === void 0) { params = null; }
        var expenseUrl = this.baseUrl + 'invoices/download_pdfs/';
        var _scope = lodash_1.clone(decamelizeKeysDeep(scope));
        return this.http.post(expenseUrl + '?' + params, _scope, {
            headers: api_service_1.requestHeaders()
        }).pipe(operators_1.catchError(api_service_1.handleError));
    };
    ExpenseService.prototype.getNext = function () {
        var _this = this;
        if (this.nextUri) {
            return this.http.get(this.nextUri, { headers: api_service_1.requestHeaders() }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
        }
        else {
            return null;
        }
    };
    ExpenseService.prototype.extractData = function (res) {
        var resObj = res;
        this.nextUri = resObj['next'];
        var body = resObj['results'];
        this.count = resObj['count'];
        if (body) {
            return body.map(function (expense) {
                return new expense_1.Expense(expense);
            });
        }
        else if (resObj) {
            return new expense_1.Expense(resObj);
        }
    };
    return ExpenseService;
}());
exports.ExpenseService = ExpenseService;
